// extracted by mini-css-extract-plugin
module.exports = {"Container":"Inbox_Container__1g9uA","Empty":"Inbox_Empty__1hO0E","ResultItem":"Inbox_ResultItem__2Z1-_","ResultFooter":"Inbox_ResultFooter__1iHUX","Repo":"Inbox_Repo__1_BeR"};